import { HeaderLinkProps } from "../types/HeaderLinkProps";

const HeaderLinks: HeaderLinkProps[] = [
  {
    name: "About",
    icon: "fa-solid fa-address-card",
    offset: 35,
    duration: 1500,
  },
  {
    name: "Skills",
    icon: "fa-solid fa-bars-progress",
    offset: -70,
    duration: 1000,
  },
  {
    name: "Experience",
    icon: "fa-solid fa-clock-rotate-left",
    offset: -100,
    duration: 1000,
  },
  {
    name: "Projects",
    icon: "fa-solid fa-code",
    offset: -20,
    duration: 1000,
  },
  {
    name: "Contact",
    icon: "fa-solid fa-envelope",
    offset: -110,
    duration: 1500,
  },
];

export default HeaderLinks;
